export default {"src":"__ASTRO_ASSET_IMAGE__BwSX1QeM__","width":14,"height":14,"format":"svg"}